import { Button, chakra, Heading, Input, Box, useToast, Flex, Text } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '../../../app/typedReduxHooks'
import { RootState } from '../../../app/store'
import { STATUS } from '../../../constants'
import { updateOrganizationData } from '../OrganizationSlice'

const FormWithStyle = chakra('form')

const OrganizationDetails = ({ isAbleToManageOrg }: { isAbleToManageOrg?: boolean }) => {
  const dispatch = useAppDispatch()
  const organization = useSelector((state: RootState) => state.organization?.data)
  const toast = useToast()
  const { updateOrganizationProfile } = useSelector(
    (state: RootState) => state.organization?.status
  )
  const { register, handleSubmit } = useForm()

  if (!organization) {
    return null
  }

  const handleUpdate = async (value: any) => {
    try {
      if (organization.id) {
        await dispatch(updateOrganizationData({ id: organization.id, ...value })).unwrap()
        toast({
          title: 'Organization profile updated successfully',
          status: 'success',
          duration: 3000,
          position: 'top',
        })
      }
    } catch (error) {
      toast({
        title: 'Failed to update organization profile',
        status: 'error',
        duration: 3000,
        position: 'top',
      })
    }
  }

  return (
    <Box flex={1}>
      <Heading as="h3" size="sm" mb={1} color="gray.800" fontWeight="bold">
        Organisation Profile
      </Heading>
      <Text fontSize="sm" color="gray.500" mb={6}>
        Update your organisation's display name
      </Text>

      <FormWithStyle onSubmit={handleSubmit(handleUpdate)} w="100%" maxW="500px">
        <Box mb={2}>
          <Text fontSize="sm" fontWeight="medium" color="gray.700" mb={2}>
            Name
          </Text>
          <Flex gap={4}>
            <Input
              disabled={!isAbleToManageOrg}
              placeholder="Name"
              bg="white"
              {...register('name', { value: organization.name || '' })}
            />
            {isAbleToManageOrg && (
              <Button
                colorScheme="blue"
                size="md"
                type="submit"
                px={8}
                isLoading={updateOrganizationProfile === STATUS.PENDING}
                loadingText="Saving"
              >
                Save
              </Button>
            )}
          </Flex>
        </Box>
      </FormWithStyle>
    </Box>
  )
}

export default OrganizationDetails
